<template>
	<div v-if="notification_data">
		<h4 class="section-title">Edit notification: {{ notification_data.name }}</h4>
		
		<small v-if="notification_data.key != 'welcome_sms'">
			<p class="mt-2 mb-1">You can personalize all the text fields with: </p>
			<ul>
				<li>%FIRST_NAME%: first name of the HHA</li>
				<li>%LAST_NAME%: last name of the HHA</li>
				<li>%AGENCY_NAME%: name of the agency</li>
				<li>%PROGRAM_NAME%: name of the program</li>
				<li>%APPROVING_MANAGER%: name of the approving manager</li>
				<li>%RESET_PASSWORD_LINK%: link for reset password</li>
				<li>%SSN%: SSN of the HHA</li>
				<li>%EMAIL%: email of the HHA</li>
				<li>%PHONE%: phone number of the HHA</li>
			</ul>
		</small>

		<form @submit.prevent="onSubmit">
			
			<label  v-if="notification_data.key != 'welcome_sms'">Send email</label>

			<div class="checkbox-container squared " v-if="notification_data.key != 'welcome_sms'" >
				<input id="checkbox-email" type="checkbox" v-model="notification_data.email"/>
				<label for="checkbox-email"></label>
				
			</div>

			<div class="form-group input-content"  v-if="notification_data.key != 'welcome_sms'">
				<label>Email subject</label>
				<input type="text" v-model="notification_data.email_subject" />
			</div>

			<div class="form-group input-content"  v-if="notification_data.key != 'welcome_sms'">
				<label>Text for email</label>
				<wysiwyg v-model="notification_data.text_email" />
			</div>

			<label  v-if="notification_data.key != 'welcome_sms'">Send push</label>
			
			<div class="checkbox-container squared "  v-if="notification_data.key != 'welcome_sms'">
				<input id="checkbox-push" type="checkbox" v-model="notification_data.push"/>
				<label for="checkbox-push"></label>
			</div>

			<p v-if="notification_data.key == 'welcome_sms'">
				You can use <a href="https://bitly.com/" target="_blank" class="text-underline">bitly</a> to generate the url. The url is
					{{ notification_data.url_redirect }}
			</p>
			<div class="form-group input-content">
				<label>Text for 
					<span v-if="notification_data.key != 'welcome_sms'">push</span>
					<span v-else>sms</span>
				</label>
				<input type="text" v-model="notification_data.text_push" />
			</div>

			<button type="submit" class="button">Submit</button>
			<router-link :to="{ name : 'admin.notification-management.index' }" tag="button" class="button dark-button">Back</router-link>
		</form>
	</div>
</template>

<script>
export default {
	data : function(){
		return {
			id : this.$route.params.id,
			notification_data : null
		}
	},

	created : function(){
		this.getNotificationManagement();
	}, 

	methods : {
		getNotificationManagement : function(){

			var params = {
				id : this.id
			}

			this.$store.dispatch('getNotificationManagementDetail', params).then((res) => {
				this.notification_data = res.data.data;
			}).catch((error) => {	
				console.log(error);
			})
		},
		onSubmit : function(){

			this.$validator.validateAll().then((result) => {
				if(result){
					this.$store.dispatch('editNotificationManagement', this.notification_data).then((res) => {
						this.$router.push({ name : 'admin.notification-management.index' });
					}).catch((error) => {
						console.log(error);
					});
				}
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/notification_management/AdminNotificationManagementEditComponent.vue